export const brandOverlayIsInUse = {
  type: "boolean"
};
